
import App from './App.tsx'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { PostHogProvider } from 'posthog-js/react'
import * as Sentry from '@sentry/react'
import './index.css'

// Initialize Sentry for error tracking
Sentry.init({
  dsn: "https://b188387811b7cfbbd64bc20db665da79@o4510451661537280.ingest.de.sentry.io/4510451789201488",
  environment: import.meta.env.MODE,
  enabled: import.meta.env.PROD, // Only in production
  sendDefaultPii: true
})


const options = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  defaults: '2025-05-24',
} as const

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element not found')
}

createRoot(rootElement).render(
  <StrictMode>
    <PostHogProvider apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY} options={options}>
      <App />
    </PostHogProvider>
  </StrictMode>
)